module.exports = __webpack_public_path__ + "img/email.cb062a17.png";